import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@emotion/react';
import { CheckStatisticsIconBlack } from 'public/assets';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import theme from '@styles/theme';
import { ChoiceRate } from '@/customTypes/chatStory';

interface IChoiceStatisticsItem {
  statement?: ChoiceRate;
}

const ChoiceStatisticsItem = ({ statement }: IChoiceStatisticsItem) => {
  const { t } = useTranslation();
  const { onGetChoiceResult } = useChatPlayContext();

  const onChoiceResult = () => {
    statement?.storyId &&
      statement?.chapterId &&
      statement?.choiceId &&
      onGetChoiceResult({
        storyId: statement?.storyId,
        chapterId: statement?.chapterId,
        choiceId: statement?.choiceId,
      });
  };

  return (
    <div css={container}>
      <div className="line"></div>
      <div
        className="itemBG"
        onClick={(e) => {
          onChoiceResult();
          e.stopPropagation();
        }}
      >
        <div className="item">
          <CheckStatisticsIconBlack />
          <div>{t('chat_screen_button_review_statistics')}</div>
        </div>
      </div>
    </div>
  );
};

const container = css`
  margin: 1em;
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;

  .itemBG {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15.5px;
    background-color: ${theme.colors.gray200};
  }

  .item {
    border-radius: 100px;
    padding: 12.5px 15.5px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.white};
    gap: 6.5px;
    border: 1px solid ${theme.colors.gray400};
  }

  .line {
    height: 1px;
    width: 100%;
    background-color: ${theme.colors.gray400};
  }
`;

export default ChoiceStatisticsItem;
